"use strict";

angular.module("customer")
.service("UserPartnershipService", function($resource, $http, gettextCatalog, appConfig) {
    var queryResource = $resource(appConfig.API_SERVER + "/auth/customer/user-partnerships/:id/", {id: "@id"}, {
        query: {
            method: "get",
            isArray: false
        }
    });
    var unpaidInvoicesStatementSummaryResource = $resource(appConfig.API_SERVER + "/invoice/customer/sales-rep/unpaid-statement/summary/", {}, {
        query: {
            method: "get",
            isArray: false,
            ignoreLoadingBar: true
        }
    });

    this.query = function(params) {
        return queryResource.query(params);
    };

    this.getUnpaidInvoicesStatementSummary = function() {
        return unpaidInvoicesStatementSummaryResource.query();
    };

    this.getLastOrderFilterHtmlContent = function() {
        return gettextCatalog.getString("Help-Tip HTML: User Customer listing last order filter.");
    };

    this.getLastInvoiceFilterHtmlContent = function() {
        return gettextCatalog.getString("Help-Tip HTML: User Customer listing last invoice filter.");
    };

    this.getOrderDeadlineFilterHtmlContent = function() {
        return gettextCatalog.getString("Help-Tip HTML: User Customer listing order deadline filter.");
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-partnership/user-partnership.service.js
// module id = 944
// module chunks = 0